// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__3nCQi","heading":"card_heading__2ztls"};